export const AUTH_URL = process.env.PUBLIC_AUTH_URL
export const ADMIN_URL = process.env.PUBLIC_ADMIN_URL
export const CATALOG_URL = process.env.PUBLIC_CATALOG_URL

export const AVATAR_COLORS = [
  '#5458e8',
  '#1822a4',
  '#37e79c',
  '#040080',
  '#2a9aad',
  '#3365cd',
  '#27b491',
  '#3cb6ef',
  '#726ef2',
  '#34c2af',
  '#1f619f',
  '#aa50fa',
  '#c892ef'
]
